export const USERS = 'USERS';
export const ENTITIES = 'ENTITIES';
export const DEVICES = 'DEVICES';
export const DEVICES_ONLY = 'DEVICES_ONLY';
export const SERVERS = 'SERVERS';
export const SERVERS_ONLY = 'SERVERS_ONLY';
export const AD_ENTITIES_AND_LOCAL_ACCOUNTS = 'AD_ENTITIES_AND_LOCAL_ACCOUNTS';
